<template>
  <v-container>
    <h2 class="mt-5 mb-10">{{$t('monthly_report')}}</h2>
    <v-card class="px-3 my-3">
      <v-row>
        <!-- <v-col md="3"><v-text-field v-model="start_date"></v-text-field></v-col>
        <v-col md="3"><v-text-field v-model="end_date"></v-text-field></v-col> -->
        <v-col md="3" class="pb-0">
          <v-menu
            ref="menu"
            v-model="menu_start"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="dateFormatted(start_date)"
                :label="$t('start_date')"
                prepend-icon="mdi-calendar"
                readonly
                v-on="on"
                color="primary"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="start_date"
              @change="onStartDateChange"
              no-title
              scrollable
              :locale="$t('locale')"
            >
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col md="3" class="pb-0">
          <v-menu
            ref="menu"
            v-model="menu_end"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="dateFormatted(end_date)"
                :label="$t('end_date')"
                prepend-icon="mdi-calendar"
                readonly
                v-on="on"
                color="primary"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="end_date"
              @change="onEndDateChange"
              no-title
              scrollable
              :min="start_date"
              :locale="$t('locale')"
            >
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col md="3">
          <v-autocomplete
            :label="$t('find_group')"
            :items="group_list"
            v-model="selected_group_id"
            item-text="alias"
            item-value="id"
            v-on:change="onGroupChange"
            :rules="[validator.alfaNumberNotRequired]"
          ></v-autocomplete>
        </v-col>
        <v-col md="3" class="pa-6">
          <download-excel
            :data="download"
            :worksheet="$t('user_summary')"
            :name="file_name"
            :disabled="checkFileExists">
            <v-btn block outlined color="primary" :disabled="checkFileExists">
              <v-icon>mdi-download</v-icon>
              {{$t('download_report')}}
            </v-btn>
          </download-excel>
        </v-col>
      </v-row>
    </v-card>
    <v-row>
      <v-col md="3">
        <v-card>
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="headline mb-1 error--text">{{
                milisToTime(statistics.companyDurationDeduction)
              }}</v-list-item-title>
              <v-list-item-subtitle>{{$t('total_late')}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col md="3">
        <v-card>
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="headline mb-1 error--text"
                >Rp
                {{
                  toNumeral(statistics.companyDeductionNominal)
                }}</v-list-item-title
              >
              <v-list-item-subtitle>{{$t('total_deduction')}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col md="3">
        <v-card>
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="headline mb-1 success--text">{{
                milisToTime(statistics.companyDurationWorkhour)
              }}</v-list-item-title>
              <v-list-item-subtitle>{{$t('total_working_hour')}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col md="3">
        <v-card>
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="headline mb-1 success--text"
                >Rp {{ toNumeral(statistics.totalPayroll) }}</v-list-item-title
              >
              <v-list-item-subtitle>{{$t('total_payroll')}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>

    <v-card class="mt-4">
      <v-data-table
        :loading="loading"
        :loading-text="$t('loading_attendance')"
        :headers="headers"
        :items="attendances"
        :sort-by="['fullname']"
        :no-data-text="$t('no_data')"
        :footer-props="{ 'items-per-page-options': [10, 50, 100], 'items-per-page-text': $t('rows_per_page') }"
      >
        <template v-slot:item.totalDurationDeduction="{ item }">
          {{ milisToTime(item.totalDurationDeduction) }}
        </template>
        <template v-slot:item.totalDurationWorkhour="{ item }">
          {{ milisToTime(item.totalDurationWorkhour) }}
        </template>
        <template v-slot:item.totalDeductionNominal="{ item }">
          Rp. {{ toNumeral(item.totalDeductionNominal) }}
        </template>
        <template v-slot:item.payroll="{ item }">
          Rp. {{ toNumeral(item.payroll) }}
        </template>
        <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}} {{ items.itemsLength }} </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
import moment from "moment";
import numeral from "numeral";
export default {
  name: "group-report",
  data() {
    return {
      validator: this.$store.state.validator,
      baseUrl: this.$store.state.baseUrl,
      headers: [
        { text: this.$i18n.t('name'), value: "fullname" },
        { text: this.$i18n.t('deduction_time'), value: "totalDurationDeduction" },
        { text: this.$i18n.t('deduction_rp'), value: "totalDeductionNominal" },
        { text: this.$i18n.t('work_time'), value: "totalDurationWorkhour" },
        { text: this.$i18n.t('work_rp'), value: "payroll" }
      ],
      loading: false,
      start_date: "",
      end_date: "",
      menu_start: false,
      menu_end: false,
      file_name: "",
      selected_group_id: "",
      group_list: [],
      statistics: {},
      attendances: [],
      download: [],
    };
  },
  computed: {
    checkFileExists() {
      if (this.file_name == "") {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    toNumeral(number) {
      return numeral(number).format("0,0");
    },
    milisToTime(milis) {
      let d = moment.duration(milis, "milliseconds");
      let hours = Math.floor(d.asHours());
      let mins = Math.floor(d.asMinutes()) - hours * 60;
      return this.toNumeral(hours) + " " + this.$i18n.t('hrs') + " " + mins + " " + this.$i18n.t('min');
    },
    onStartDateChange() {
      const diff = moment(this.end_date).diff(this.start_date, 'days')
      if (diff < 0) this.end_date = this.start_date
      this.menu_start = false;
    },
    onEndDateChange() {
      this.menu_end = false;
    },
    onGroupChange() {
      this.loading = true;
      const filename = this.group_list.find(e => {return e.id == this.selected_group_id}).alias
      let date_start = moment(this.start_date).format("DD-MM-YYYY");
      let date_end = moment(this.end_date).format("DD-MM-YYYY");
      this.file_name = `${this.$i18n.t('monthly_report')} ${filename.replace(/[.:,]/g,'')} (${date_start} - ${date_end})`
      if (this.selected_group_id) {
        this.getGroupStatistics(this.selected_group_id);
      } else {
        this.fetchSummary()
      }
    },
    dateFormatted(date) {
      return moment(date).locale(this.$i18n.t('lang')).format("Do MMMM YYYY");
    },
    mapDownloadFile(data) {
      this.download = []

      data.map(item => {
        this.download.push({
          [this.$i18n.t('user_id')]: item.userid,
          [this.$i18n.t('employeeCode')]: item.employeecode,
          [this.$i18n.t('full_name')]: item.fullname,
          [this.$i18n.t('email')]: item.email,
          [this.$i18n.t('payroll')]: item.payroll,
          [this.$i18n.t('total_deduction_nominal')]: item.totalDeductionNominal,
          [this.$i18n.t('total_duration_deduction')]: item.totalDurationDeduction,
          [this.$i18n.t('total_duration_work_hour')]: item.totalDurationWorkhour,
          [this.$i18n.t('percentage_work_hour')]: item.percentageWorkhour,
        })
      })
      this.download = this.download.sort((v1,v2) => { if (v1[this.$i18n.t('full_name')] < v2[this.$i18n.t('full_name')]) { return -1; } if (v1[this.$i18n.t('full_name')] > v2[this.$i18n.t('full_name')]) { return 1; } return 0; })
    },
    async fetchSummary() {
      this.loading = true;
      let company_id = this.$store.state.company;
      let date_start = moment(this.start_date).format("DD-MM-YYYY");
      let date_end = moment(this.end_date).format("DD-MM-YYYY");
      this.file_name = `${this.$i18n.t('monthly_report')} (${date_start} - ${date_end})`
      const params = { companyId: company_id, startDate: date_start, endDate: date_end }
      const result = await this.$store.dispatch('getReportSummaryPerCompany', params)
      this.statistics = result.company;
      this.attendances = result.users
      this.mapDownloadFile(result.users)  
      // const pattern = /^([aA]dmin.)((?!\.)[\w-_.]*[^.])(@appsensi+)(\.\w+(\.\w+)?[^.\W])$/
      // res.data.users.forEach(row => {
      //   if (!pattern.test(row.email)) {
      //     let report = {}
      //     report.employeecode = row.employeecode
      //     report.fullname = row.fullname
      //     report.email = row.email
      //     report.totalDeductionNominal = row.totalDeductionNominal
      //     report.totalDurationDeduction = this.milisToTime(row.totalDurationDeduction)
      //     report.totalDurationWorkhour = this.milisToTime(row.totalDurationWorkhour)
      //     report.payroll = row.payroll
      //     this.users.push(report);
      //   }
      // });
      this.loading = false;
    },
    async getGroupList() {
      let companyId = this.$store.state.company;
      const result = await this.$store.dispatch('getGroupByCompany', { companyId })
      this.group_list = [{alias: this.$i18n.t('all'), id: null}];
      result.forEach(row => {
        let group = row;
        this.group_list.push(group);
      })
    },
    async getGroupStatistics(group_id) {
      let date_start = moment(this.start_date).format("DD-MM-YYYY");
      let date_end = moment(this.end_date).format("DD-MM-YYYY");
      const params = { groupId: group_id, startDate: date_start, endDate: date_end }
      const result = await this.$store.dispatch('getReportSummaryPerCompanyByGroup', params)
      this.loading = false;
      this.statistics = result.company;
      this.attendances = result.users;
      this.mapDownloadFile(result.users)  
    }
  },
  created() {
    this.start_date = moment()
      .startOf("month")
      .format("YYYY-MM-DD");
    this.end_date = moment().format("YYYY-MM-DD");
    this.getGroupList();
  }
};
</script>
